import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";

export function telefoneValidator(control: AbstractControl): ValidationErrors | null {
    var reNormal = new RegExp(/\([1-9]\d\)9?\d{4}-\d{4}/g);
    let regexTelefone = new RegExp(/(^[0-9]{2})?(\s|-)?(9?[0-9]{4})-?([0-9]{4}$)/gm);

    let value = control.value;

    if (value)
        value = value.toString().replace(/\s+/g, '');

    if (value != undefined && value != null && value != '') {
        let numbers = value.match(/\d/g);
        let numberLength = 0;
        if (numbers) {
            numberLength = numbers.join("").length;
        }
        if (numberLength == 10 && regexTelefone.test(value))
            return null;

        if (numberLength == 11 && regexTelefone.test(value))
            return null;


        return {
            telefone: true,
            mensagem:(campo:string)=>`O campo <b>${campo}</b> não é um telefone válido`
        }
    }
    return null;
}


